import { DietType } from "../diets";

export const dietsIt: DietType[] = [
    {
        id: "keto",
        name: "Keto",
        description: "Dieta ricca di grassi e povera di carboidrati",
        objective:
            "Perdita di peso e regolazione dei livelli di zucchero nel sangue",
    },
    {
        id: "vegetarian",
        name: "Vegetariana",
        description: "Alimentazione a base vegetale ricca di nutrienti",
        objective:
            "Miglioramento della salute generale e riduzione dell'impatto ambientale",
    },
    {
        id: "paleo",
        name: "Paleo",
        description:
            "Alimenti integrali basati su uno stile alimentare ancestrale",
        objective: "Perdita di peso e riduzione dell'infiammazione",
    },
    {
        id: "lowcarb",
        name: "Low-Carb",
        description:
            "Dieta a basso contenuto di carboidrati con proteine e grassi",
        objective: "Perdita di peso o mantenimento",
    },
    {
        id: "mediterranean",
        name: "Mediterranea",
        description:
            "Dieta a base di alimenti integrali, olio d'oliva, pesce e noci",
        objective: "Salute cardiovascolare e mantenimento",
    },
    {
        id: "intermittentfasting",
        name: "Digiuno Intermittente",
        description: "Alternanza di periodi di digiuno e alimentazione",
        objective: "Controllo calorico e perdita di grasso",
    },
    {
        id: "highprotein",
        name: "Alta Proteina",
        description:
            "Dieta ad alto contenuto proteico per preservare la massa muscolare",
        objective: "Sviluppo e mantenimento muscolare",
    },
    {
        id: "zone",
        name: "Zona",
        description: "Equilibrio 40% carboidrati, 30% proteine e 30% grassi",
        objective: "Stabilizzazione della glicemia e controllo del peso",
    },
    {
        id: "vegan",
        name: "Vegana",
        description: "Dieta completamente vegetale",
        objective: "Salute generale e sostenibilità ambientale",
    },
    {
        id: "carnivore",
        name: "Carnivora",
        description: "Dieta basata solo su carne, pesce e prodotti animali",
        objective: "Perdita di peso estrema e riduzione dell'infiammazione",
    },
    {
        id: "flexible",
        name: "Dieta Flessibile",
        description: "Alimentazione flessibile che rispetta i macronutrienti",
        objective: "Flessibilità per obiettivi estetici o sportivi",
    },
    {
        id: "dash",
        name: "DASH",
        description: "Dieta ricca di frutta, verdura e cereali integrali",
        objective: "Salute cardiovascolare e riduzione dell'ipertensione",
    },
];
